// import external dependencies
import 'jquery';

window.axios = require('axios');
import Vue from 'vue';

import VueLodash from 'vue-lodash'
import { filter, map, groupBy, uniqBy, random, sampleSize, flatMap, findIndex, reduce } from 'lodash'
//import filter from 'lodash/filter'
//import map from 'lodash/map'
//import groupBy from 'lodash/groupBy'
//import uniq

import VModal from 'vue-js-modal'
Vue.use(VModal)

import { VueperSlides, VueperSlide } from 'vueperslides'


Vue.component('VueperSlides', VueperSlides)
Vue.component('VueperSlide', VueperSlide)

Vue.use(VueLodash, { name: 'custom', lodash: { map, filter, groupBy, uniqBy, random, sampleSize, flatMap, findIndex, reduce } })

// Import everything from autoload

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

//import Fitty from 'vue-fitty' 
//Vue.use(Fitty);

Vue.filter('stripHtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

Vue.directive('balance-text', require('vue-balance-text'))

import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt, faPhone, faEnvelope, faLink, faStar, faCameraRetro, faVideo, faImage, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faMapMarkerAlt, faPhone, faEnvelope, faLink, faStar, faCameraRetro, faVideo, faImage, faAngleLeft, faAngleRight)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Glide from '@glidejs/glide'
//import VueGlide from 'vue-glide-js'
//Vue.use(VueGlide)

import Datepicker from 'vuejs-datepicker';
Vue.component('Datepicker', Datepicker)

import Glide from '@glidejs/glide'
import VueGlide from 'vue-glide-js'
Vue.use(VueGlide)

import FlickitySlider from './components/FlickitySlider.vue';
Vue.component('FlickitySlider', FlickitySlider)

import HomeSlider from './components/HomeSlider.vue';
Vue.component('HomeSlider', HomeSlider);

import HomeFeatures from './components/HomeFeatures.vue';
Vue.component('HomeFeatures', HomeFeatures);

import UpcomingEvents from './components/UpcomingEvents.vue';
Vue.component('UpcomingEvents', UpcomingEvents)

import HomeThingsToDo from './components/HomeThingsToDo.vue';
Vue.component('HomeThingsToDo', HomeThingsToDo);

import ThingsToDo from './components/ThingsToDo.vue';
Vue.component('ThingsToDo', ThingsToDo);

import DirectoryCustom from './components/DirectoryCustom.vue';
Vue.component('DirectoryCustom', DirectoryCustom);

import PlacesToStay from './components/PlacesToStay.vue';
Vue.component('PlacesToStay', PlacesToStay);

import PlacesToStayFeatured from './components/PlacesToStayFeatured.vue';
Vue.component('PlacesToStayFeatured', PlacesToStayFeatured);

import EatDrink from './components/EatDrink.vue'
Vue.component('EatDrink', EatDrink)

import EatDrinkFeatured from './components/EatDrinkFeatured.vue'
Vue.component('EatDrinkFeatured', EatDrinkFeatured)

import Events from './components/Events.vue'
Vue.component('Events', Events)

import ThingsToDoFeatured from './components/ThingsToDoFeatured.vue';
Vue.component('ThingsToDoFeatured', ThingsToDoFeatured);

import HomeLocalStories from './components/HomeLocalStories.vue';
Vue.component('HomeLocalStories', HomeLocalStories);

import LocalStories from './components/LocalStories.vue';
Vue.component('LocalStories', LocalStories);

import LocalStoriesMast from './components/LocalStoriesMast.vue';
Vue.component('LocalStoriesMast', LocalStoriesMast);

import Directions from './components/Directions.vue';
Vue.component('Directions', Directions);

import StoryBlock from './components/StoryBlock.vue'
Vue.component('StoryBlock', StoryBlock)

import MediaBlock from './components/MediaBlock.vue'
Vue.component('MediaBlock', MediaBlock)

import MenuBlocks from './components/MenuBlocks.vue'
Vue.component('MenuBlocks', MenuBlocks)

import MenuModals from './components/MenuModals.vue'
Vue.component('MenuModals', MenuModals)

import Tour from './components/Tour.vue'
Vue.component('Tour', Tour)

import FeaturedTours from './components/FeaturedTours.vue'
Vue.component('FeaturedTours', FeaturedTours)

import Shopping from './components/Shopping.vue'
Vue.component('Shopping', Shopping)

import ShoppingFeatured from './components/ShoppingFeatured.vue'
Vue.component('ShoppingFeatured', ShoppingFeatured)

import Venue from './components/Venue.vue'
Vue.component('Venue', Venue)

import WelcomeKit from './components/WelcomeKit.vue'
Vue.component('WelcomeKit', WelcomeKit)

import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true //created computed members from your variable declarations
})


import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultClass: 'ew-tooltip',
  delay: { show: 500, hide: 1000 },
  autoHide: false
})

//import LocalStories from './components/LocalStories.vue'
//Vue.component('LocalStories', LocalStories)

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(window).load(() => {
    
    routes.loadEvents()


  }
  
);



Vue.mixin({
  created() {
    this.currentItinerary = this.$ls.get('_ew_planner_itinerary', [], Array);
    let initMixin = setInterval(() => {
        if ( this.plannerExists ) {
          clearInterval(initMixin);
          window.$trEventBus.$on('itinerary-updated', () => {
              this.currentItinerary = this.$ls.get('_ew_planner_itinerary', [], Array)
          });
        }
    }, 500);
  },
  computed: {
    currentSession: function() {
      return this.$ls.get('_ew_planner_session_object', {}, Object)
    },
    showLoader: function() {
      return this.$store.state.ui.showLoader
    },
    plannerExists() {
      return typeof window.$trEventBus !== 'undefined'
    }
  },
  filters: {
    pluralize: function (value, count) {
      return pl( value, count );
    },
  },
  data() {
    return {
      $publicPath: process.env.MIX_APP_URL,
      appPath: process.env.MIX_APP_URL,
      currentItinerary: [],
      testing: 'testing',
    }
  },
  methods: {
    generateLink(link) {
      let anchor = { target: "_self" }; 
      if ( link.link_type == 'custom' ) {
        anchor.target = link.custom.target;
        anchor.url = link.custom.url;
      } else if ( link.link_type == 'event' ) {
        anchor.url = `#/event/${link.event}`;
      } else if ( link.link_type == 'post' ) {
        anchor.url = `#/post/${link.post}`;
      } else if ( link.link_type == 'venue' ) {
        anchor.url = `#/venue/${link.venue}`;
      } else if ( link.link_type == 'tour' ) {
        anchor.url = `#/tour/${link.tour}`;
      } else if ( typeof link.link_type === 'undefined' ) {
        return link;
      }
      return anchor;
    },
    formatDateFrom(date, from, to) {
      return DateTime.fromFormat(date, from).toFormat(to);
    },
    setCurrentItinerary: function(itinerary) {

      this.currentItinerary = _.map(itinerary, (item) => {
        item.id = parseInt(item.id);
        item.object_id = parseInt(item.object_id);
        return item;
      });
      this.$ls._lsSet('_ew_planner_itinerary', itinerary, Array);
    },
    getItinerary: function() {

    },
    getSession: function() {
      return this.$ls.get('_ew_planner_itinerary', [], Array);
    },
    itineraryHasItem: function(item) {
      let idx = _.findIndex(this.currentItinerary, (existing) => {
        return existing.data_type == item.data_type && existing.object_id == item.object_id
      });
      return idx > -1;
    },
    toggleItineraryItem: function (item) {
      let action = 'add';
      let idx = _.findIndex(this.currentItinerary, (existing) => {
        return existing.data_type == item.data_type && existing.object_id == item.object_id
      });
      if ( idx < 0 ) {
        this.currentItinerary.push(item);
      } else {
        action = 'remove';
        this.currentItinerary.splice(idx, 1);
      }

      this.$ls._lsSet('_ew_planner_itinerary', this.currentItinerary, Array);

      window.$trEventBus.$emit('itinerary-updated');

      let data = item;
      axios({
        method: 'post',
        url: `https://tripriffic.com/api/${action}_itinerary_item`,
        data: { item: item }
      })
      .then((response) => {
        //console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    }
  }
})




var app = new Vue({
  el: '#app',
  data() {
    return {
      test: 'test message',
    }
  },
  components: {

  },
  mounted() {
    



  },
  methods: {
    openModal(idx) {
      this.activeModal = idx;
    },
    closeModal() {
      this.activeModal = false;
    }

  }
});

var app2 = new Vue({
  el: '#menu-items',
  data() {
    return {
      media: menu_blocks,
      pyv_media: pyv_media,
      activeModal: false,
      menuVisible: false,
      localFavoritesVisible: false,
      showSearch: false,
      searchKeyword: ''
    }
  },
  components: {

  },
  mounted() {
    console.log('blocks', menu_blocks);

    this.$on('openModal', (block) => {
      this.activeModal = block;
    });
    this.$on('closeModal', (block) => {
      this.activeModal = false;
    });

    

  },
  methods: {
    submitSearch() {
      window.location.href = "/?s="+this.searchKeyword
    },
    openSearch() {
      this.showSearch = true;
    },
    closeSearch() {
      this.showSearch = false;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    toggleLocalFavorites() {
      this.localFavoritesVisible = !this.localFavoritesVisible;
    },
    openModal(idx) {
      alert(idx);
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    }
  }
});

/*
console.log('getting ready');
window.addEventListener('load', (e) => {
  console.log('triggered');
  let el = document.querySelector(".mobile-nav .local-favorites-parent a");
  console.log('el:', el);
  el.addEventListener('click', (event) => {
    console.log('event', event);
    document.querySelector(".mobile-nav .local-favorites-parent").classList.toggle("active");
  });
});*/


// WEBPACK FOOTER //
// ./scripts/main.js